import { useLanguage } from "@/contexts/LanguageContext";

export const AssociatedCompanies = () => {
  const { t } = useLanguage();
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">{t("setup.tabs.empresasAssociadas")}</h2>
      <div className="p-4 bg-gray-50 rounded-lg">
        <p>Associated Companies component placeholder</p>
      </div>
    </div>
  );
};
